(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.KabluchkaVariantSelection = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function findSoleCompatibleDependentOption(groups, changedGroupIndex) {
    for (let index = changedGroupIndex + 1; index < groups.length; index += 1) {
      const options = groups[index].options || [];
      const checkedOption = options.find((option) => option.checked);
      const enabledOptions = options.filter((option) => !option.disabled);

      if (checkedOption?.disabled && enabledOptions.length === 1) {
        return enabledOptions[0];
      }
    }

    return null;
  }

  function getSoleCompatibleDependentInput(variantSelects, changedOptionId) {
    if (!variantSelects || !changedOptionId) return null;

    const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
    const changedGroupIndex = fieldsets.findIndex((fieldset) =>
      Array.from(fieldset.querySelectorAll('input[type="radio"]')).some((input) => input.id === changedOptionId)
    );

    if (changedGroupIndex === -1) return null;

    const groups = fieldsets.map((fieldset) => ({
      options: Array.from(fieldset.querySelectorAll('input[type="radio"]')).map((input) => ({
        id: input.id,
        checked: input.checked,
        disabled: input.disabled || input.classList.contains('disabled') || input.classList.contains('visually-disabled'),
      })),
    }));
    const candidate = findSoleCompatibleDependentOption(groups, changedGroupIndex);

    if (!candidate) return null;

    return Array.from(variantSelects.querySelectorAll('input[type="radio"]')).find(
      (input) => input.id === candidate.id
    ) || null;
  }

  return {
    findSoleCompatibleDependentOption,
    getSoleCompatibleDependentInput,
  };
});
